import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/reset.css';
import App from './App.vue'
import router from './router'
import store from './store'
// 全局样式
import '@/assets/styles/global.less'
// 设备识别（首屏渲染前确定桌面/移动布局）
import '@/utils/device'
// 按钮级权限指令
import permission from '@/directives/permission'
// import MyHeader from '@/components/practive/MyHeader.vue'

// 创建Vue实例
createApp(App)
.use(store) // vuex状态管理
.use(router) // 全局路由配置
.use(ElementPlus)
.use(Antd)
.directive('permission', permission) // v-permission
// .component('myheader', MyHeader) // 全局组件
.mount('#app') // 绑定到id为app的元素上
